// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"111":"10799f9a","764":"402a9c5f","860":"8d134938"}[chunkId] + ".chunk.js";
};